import { render } from "./FirstTimeUserPage.vue?vue&type=template&id=90eb1a36"
import script from "./FirstTimeUserPage.vue?vue&type=script&lang=js"
export * from "./FirstTimeUserPage.vue?vue&type=script&lang=js"

import "../assets/css/style.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__